import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Amritsartaxibooking() {



  const cardData =
  {
    keyword: 'Amritsar Taxi Booking',
    heading: 'Aaryan Travels: Amritsar Taxi Booking',
    headingDescription: ' Aaryan Travels offers quick and reliable Amritsar Taxi Booking services for local travel, sightseeing tours, airport pickups, and outstation trips. Whether you are heading to the Golden Temple, Wagah Border, Jallianwala Bagh, or planning journeys to Chandigarh, Jammu, or Pathankot, our fleet of sedans, SUVs, and tempo travellers ensures a comfortable and stress-free ride. With professional chauffeurs, transparent fares, and 24/7 service availability, we make taxi booking in Amritsar effortless and dependable. From railway station transfers to corporate travel and family tours, Aaryan Travels provides doorstep pickup and seamless taxi services across Amritsar.',

    top: 'Top Places to Visit in Amritsar with Aaryan Travels',

"topPlaces": [
  {
    "title": "Golden Temple (Harmandir Sahib)",
    "description": "The Golden Temple is the holiest pilgrimage site of Sikhism, known for its gold-plated sanctum floating peacefully in the middle of a sacred lake. Devotees from all over the world gather to listen to Gurbani hymns and experience divine serenity. The temple complex operates the world’s largest community kitchen, serving free meals to thousands daily. Its night illumination reflects beautifully in the water. The Golden Temple is Amritsar’s spiritual crown of harmony and devotion."
  },
  {
    "title": "Jallianwala Bagh",
    "description": "Jallianwala Bagh is a memorial dedicated to the victims of the 1919 massacre during British rule. The preserved bullet marks and Martyrs’ Well stand as powerful reminders of India’s struggle for freedom. A flame-shaped monument honors those who sacrificed their lives. The evening light-and-sound show narrates the tragic yet inspiring history. Jallianwala Bagh is Amritsar’s sacred ground of patriotism."
  },
  {
    "title": "Wagah Border Ceremony",
    "description": "The Wagah Border hosts the electrifying Beating Retreat Ceremony performed daily by Indian and Pakistani soldiers. Patriotic chants, synchronized drill marches, and flag-lowering rituals captivate audiences. The energy and unity in the crowd create an unforgettable atmosphere. It is one of the most thrilling military parades in the world. Wagah Border is Amritsar’s live symbol of national pride."
  },
  {
    "title": "Durgiana Temple",
    "description": "Durgiana Temple, also called the Silver Temple, resembles the architecture of the Golden Temple but is dedicated to Goddess Durga. Its sacred pond and gleaming silver doors add elegance to the divine setting. Devotees gather here during Navratri for grand celebrations. Lanterns and diyas reflect beautifully in the water during the evening. Durgiana Temple is Amritsar’s shining abode of devotion."
  },
  {
    "title": "Akal Takht",
    "description": "Akal Takht, located within the Golden Temple complex, is one of the five seats of Sikh authority established by Guru Hargobind Sahib. It represents spiritual strength combined with temporal power and justice. Devotees visit to seek blessings and witness traditional weapon displays. The structure stands as a symbol of courage and sovereignty. Akal Takht is Amritsar’s pillar of Sikh leadership."
  },
  {
    "title": "Gobindgarh Fort",
    "description": "Gobindgarh Fort is a historic military stronghold built by Maharaja Ranjit Singh. Today it is transformed into a cultural attraction featuring 7D shows, folk performances, camel rides, and traditional food courts. The light-and-sound show narrates Punjab’s glorious past. Visitors enjoy exploring its grand gates and bastions. Gobindgarh Fort is Amritsar’s celebration of royal valor."
  },
  {
    "title": "Partition Museum",
    "description": "The Partition Museum showcases real-life stories, photographs, and belongings of people affected by the 1947 partition of India. Emotional audio recordings and letters offer deep insight into their struggles and resilience. It is the world’s first museum dedicated to the history of partition. Visiting it is both moving and educational. Partition Museum is Amritsar’s archive of history and healing."
  },
  {
    "title": "Ram Bagh Gardens & Maharaja Ranjit Singh Museum",
    "description": "Ram Bagh Gardens is a serene green retreat once used by Maharaja Ranjit Singh as his summer palace. The onsite museum displays royal memorabilia, weapons, and paintings from the Sikh Empire. Fountains, sculptures, and tree-lined paths make it ideal for morning strolls. It beautifully blends history with nature. Ram Bagh is Amritsar’s regal botanical escape."
  },
  {
    "title": "Hall Bazaar",
    "description": "Hall Bazaar is one of the oldest shopping streets in Amritsar, famous for Phulkari embroidery, Punjabi juttis, spices, and handicrafts. The Mughal-style gateway at the entrance adds heritage charm. Street food stalls offer local delights like Amritsari kulcha, jalebi, and lassi. The market stays lively from morning till night. Hall Bazaar is Amritsar’s colorful shopping paradise."
  },
  {
    "title": "Khalsa College",
    "description": "Khalsa College is an architectural masterpiece built in Indo-Saracenic style in 1892. Its red sandstone façade, domes, and corridors resemble a royal palace. The vast campus is a popular spot for film shoots and photography. It holds historical significance in Punjab’s educational history. Khalsa College is Amritsar’s majestic blend of heritage and academia."
  }
],


"services": [
  {
    "name": "Amritsar Taxi Booking",
    "description": "Amritsar Taxi Booking provides quick, hassle-free access to taxis for local, airport, and outstation travel. Whether you're heading to a business meeting, shopping, or sightseeing at the Golden Temple, our service ensures a smooth ride with professional drivers, comfortable cars, and 24x7 availability. Book online or via call for instant confirmation and real-time tracking. We offer transparent pricing, flexible options, and a range of vehicle types for all your travel needs."
  },
  {
    "name": "Book Taxi Amritsar",
    "description": "Book Taxi Amritsar makes transportation convenient and efficient for daily commuters, tourists, and corporate travelers. Enjoy clean vehicles, well-trained chauffeurs, and punctual service whether you're traveling across town or to nearby destinations. Our easy booking process allows you to reserve your ride in seconds via app, website, or phone—day or night."
  },
  {
    "name": "Online Taxi Amritsar",
    "description": "With Online Taxi Amritsar, booking a cab is as simple as a few clicks. Access fast and reliable transportation services across the city with live tracking, digital payments, and instant booking confirmation. Perfect for professionals, students, and families who want to avoid the hassle of waiting or price negotiations. Just book, ride, and relax."
  },
  {
    "name": "Amritsar Cab Booking",
    "description": "Amritsar Cab Booking offers flexible cab hire services with a focus on comfort, safety, and affordability. Book a sedan, SUV, or hatchback for local travel, airport pickups, or long-distance journeys. Our 24x7 support, verified drivers, and real-time updates ensure a trustworthy and satisfying ride every time you travel."
  },
  {
    "name": "Affordable Taxi Amritsar",
    "description": "Get budget-friendly rides with Affordable Taxi Amritsar without compromising on service quality. Our fares are transparent, competitive, and perfect for regular city travel. Whether you're commuting to college, work, or the market, we ensure your rides remain economical while still offering timely pickups and courteous drivers."
  },
  {
    "name": "Best Cab Amritsar",
    "description": "Recognized for reliability and service excellence, Best Cab Amritsar is your go-to solution for all travel needs in the city. Whether you're heading to the airport, attending an event, or need a late-night pickup, we provide premium vehicles, trained drivers, and a seamless booking experience to make every journey exceptional."
  },
  {
    "name": "24x7 Taxi Amritsar",
    "description": "24x7 Taxi Amritsar ensures that no matter the hour, a clean and safe cab is always available for you. Be it early morning flights, late-night returns, or emergency travel, our round-the-clock service gives you peace of mind with dependable cabs, secure rides, and live driver tracking anytime you need us."
  },
  {
    "name": "Sedan Cab Amritsar",
    "description": "Travel in comfort with our Sedan Cab service in Amritsar. Ideal for solo travelers and small groups, our sedans offer air-conditioned comfort, ample boot space, and smooth rides. Perfect for airport transfers, client visits, or family outings, all driven by experienced and courteous chauffeurs."
  },
  {
    "name": "SUV Taxi Amritsar",
    "description": "SUV Taxi Amritsar provides spacious, comfortable rides for groups, families, or travelers with extra luggage. Ideal for local sightseeing, outstation trips, or special events, our SUVs combine power and space with professional service, ensuring a premium experience for all your travel requirements."
  },
  {
    "name": "Local Taxi Hire Amritsar",
    "description": "Local Taxi Hire in Amritsar makes short-distance travel easy and efficient. Perfect for errands, shopping trips, school runs, and work commutes, we provide instant cab availability, friendly drivers, and economical fares across the city. Book by the hour or per trip, based on your convenience."
  },
  {
    "name": "Outstation Taxi Amritsar",
    "description": "Outstation Taxi Amritsar helps you travel comfortably to nearby cities and tourist destinations. We offer one-way and round-trip cabs to places like Chandigarh, Jalandhar, and Pathankot. Our vehicles are well-maintained and equipped for long-distance comfort, with flexible packages and transparent billing."
  },
  {
    "name": "Trusted Taxi Amritsar",
    "description": "Trusted Taxi Amritsar is built on a reputation of safety, reliability, and professionalism. All drivers are verified, vehicles are GPS-enabled, and every ride is backed by 24/7 customer support. Ideal for seniors, families, and business travelers looking for worry-free travel within and outside the city."
  },
  {
    "name": "Quick Cab Booking Amritsar",
    "description": "Need a cab in a hurry? Quick Cab Booking Amritsar offers ultra-fast response times and minimal wait for your pickup. Book in real-time and get connected to the nearest available cab instantly. Perfect for urgent meetings, last-minute travel, or impromptu plans around the city."
  },
  {
    "name": "City Taxi Service Amritsar",
    "description": "Our City Taxi Service in Amritsar connects you with reliable drivers and clean vehicles for any city-based travel need. Be it commuting, dining out, shopping, or school runs, our cabs are always a tap away. Easy booking, digital payments, and real-time notifications ensure a modern and smooth ride experience."
  },
  {
    "name": "Airport Taxi Amritsar",
    "description": "Airport Taxi Amritsar provides timely and comfortable transfers to and from Sri Guru Ram Dass Jee International Airport. Our service includes real-time flight tracking, on-time pickups, and luggage assistance. Whether you’re arriving late or leaving early, our airport cabs offer a stress-free experience for travelers of all types."
  }
],
"tableData": [
  ["Amritsar Taxi Booking", "Book Taxi Amritsar"],
  ["Online Taxi Amritsar", "Amritsar Cab Booking"],
  ["Affordable Taxi Amritsar", "Best Cab Amritsar"],
  ["24x7 Taxi Amritsar", "Sedan Cab Amritsar"],
  ["SUV Taxi Amritsar", "Local Taxi Hire Amritsar"],
  ["Outstation Taxi Amritsar", "Trusted Taxi Amritsar"],
  ["Quick Cab Booking Amritsar", "City Taxi Service Amritsar"],
  ["Airport Taxi Amritsar", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Trusted Taxi Booking in Amritsar",
    "WhyChoosedescription": "Aaryan Travels offers reliable and easy taxi booking services across Amritsar for local and outstation travel."
  },
  {
    "WhyChooseheading": "Instant Pickup Anywhere in Amritsar",
    "WhyChoosedescription": "Enjoy quick and convenient pickups from any location in the city with our prompt taxi services."
  },
  {
    "WhyChooseheading": "Clean, Sanitized, and Air-Conditioned Taxis",
    "WhyChoosedescription": "Travel comfortably in well-maintained vehicles that meet high standards of hygiene and safety."
  },
  {
    "WhyChooseheading": "Experienced Local Drivers for Smooth Travel",
    "WhyChoosedescription": "Our drivers are professional, courteous, and familiar with all major routes and landmarks in Amritsar."
  },
  {
    "WhyChooseheading": "Affordable Rates with Transparent Billing",
    "WhyChoosedescription": "Get all-inclusive pricing with no hidden charges—covering tolls, fuel, and driver allowances."
  },
  {
    "WhyChooseheading": "24/7 Booking and Customer Support",
    "WhyChoosedescription": "Our team is available round the clock to help you with bookings, changes, or travel assistance."
  },
  {
    "WhyChooseheading": "Flexible Booking Options for All Travel Needs",
    "WhyChoosedescription": "Choose from point-to-point rides, hourly rentals, airport transfers, or long-distance travel."
  },
  {
    "WhyChooseheading": "Multiple Vehicle Choices for Every Group Size",
    "WhyChoosedescription": "Select hatchbacks, sedans, SUVs, or tempo travellers based on your group size and comfort preferences."
  }
]































  }

const faqData = [
  {
    question: 'Does Aaryan Travels provide taxi booking services in Amritsar?',
    answer: 'Yes, Aaryan Travels offers quick and convenient taxi booking services across Amritsar for both local and outstation travel.',
  },
  {
    question: 'How can I book a taxi in Amritsar with Aaryan Travels?',
    answer: 'You can book a taxi through our website, mobile app, or by calling our 24x7 customer support team.',
  },
  {
    question: 'What types of taxis are available for booking in Amritsar?',
    answer: 'We provide a range of vehicles including hatchbacks, sedans, SUVs, and premium cars to suit all travel needs.',
  },
  {
    question: 'Can I book Aaryan Travels taxis for outstation trips from Amritsar?',
    answer: 'Yes, we offer taxi services from Amritsar to various outstation destinations with professional drivers and well-maintained cars.',
  },
  {
    question: 'Is airport taxi service available in Amritsar?',
    answer: 'Yes, we offer prompt and reliable airport pickup and drop services to and from Sri Guru Ram Das Jee International Airport.',
  },
  {
    question: 'Are the drivers experienced and familiar with Amritsar routes?',
    answer: 'Absolutely. Our drivers are experienced, courteous, and knowledgeable about the local and surrounding areas.',
  },
  {
    question: 'Is taxi booking service in Amritsar available 24x7?',
    answer: 'Yes, Aaryan Travels provides round-the-clock taxi services in Amritsar to meet your travel needs at any time.',
  },
  {
    question: 'What safety measures are followed during taxi services in Amritsar?',
    answer: 'All vehicles are sanitized regularly and drivers follow safety and hygiene protocols for passenger safety.',
  },
  {
    question: 'What payment methods are accepted for taxi bookings in Amritsar?',
    answer: 'We accept cash, credit/debit cards, UPI, and popular digital wallets for smooth transactions.',
  },
  {
    question: 'Can I schedule or pre-book a taxi in Amritsar?',
    answer: 'Yes, Aaryan Travels allows advance taxi bookings to ensure timely pickup as per your schedule.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Manjit Singh',
    feedback: 'Booking a taxi in Amritsar with Aaryan Travels was effortless. Great service and punctual drivers.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Rina Kapoor',
    feedback: 'Reliable and clean taxis in Amritsar. Aaryan Travels made my local travel very comfortable.',
    rating: 5,
  },
];




























































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Amritsar Taxi Booking",
  "image": "https://aaryantravels.com/assets/images/amritsar-taxi-booking.jpg", // replace with actual image URL
  "description": "Convenient and affordable Amritsar taxi booking services by Aaryan Travels. Book online for local rides, outstation trips, sedan and SUV taxis available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Aaryan Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.6",  // example rating, update if needed
    "ratingCount": "1500", // example rating count, update if needed
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "700",  // example price, adjust as needed
    "availability": "https://schema.org/InStock",
    "url": "https://aaryantravels.com/amritsar-taxi-booking"
  }
};







  return (
    <div>

<Helmet>
  <title>Amritsar Taxi Booking | Affordable & Reliable Cabs | Aaryan Travels</title>
  <meta
    name="description"
    content="Convenient and affordable Amritsar taxi booking services by Aaryan Travels. Book online for local rides, outstation trips, sedan and SUV taxis available 24x7."
  />
  <meta
    name="keywords"
    content="Amritsar Taxi Booking, Book Taxi Amritsar, Online Taxi Amritsar, Amritsar Cab Booking, Affordable Taxi Amritsar, Best Cab Amritsar, 24x7 Taxi Amritsar, Sedan Cab Amritsar, SUV Taxi Amritsar, Local Taxi Hire Amritsar, Outstation Taxi Amritsar, Trusted Taxi Amritsar, Quick Cab Booking Amritsar, City Taxi Service Amritsar, Airport Taxi Amritsar"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/31.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Amritsartaxibooking;